import React from "react";
import { Comment, Identifiable } from "@planzone/dto";

import { Comment as CommentComponent } from "./comment";
import { Comment as CommentLoader } from "../loader/comment";
import { Log } from "./log";
import { Props } from "./types";
import { Placeholder } from "./placeholder";
import { ChatInput } from "../chatInput";
import styles from "./styles.scss";

function Feed({
  resources,
  comments,
  project,
  isSubmitting,
  isLoadingOlderComments,
  onSubmitReply,
}: Props) {
  const [replyTo, setReplyTo] = React.useState<Identifiable<Comment> | null>(
    null,
  );

  const topLevelComments = comments.filter((c) => !c.replyTo);
  const repliesMap = comments
    .filter((c) => !!c.replyTo)
    .reduce<Record<string, Identifiable<Comment>[]>>((acc, reply) => {
      const parentUuid = reply.replyTo!.uuid;
      return { ...acc, [parentUuid]: [...(acc[parentUuid] ?? []), reply] };
    }, {});

  return (
    <ul className={styles.feed}>
      {topLevelComments.length > 0 ? (
        [...topLevelComments].reverse().map((comment) => (
          <React.Fragment key={comment.uuid}>
            {replyTo?.uuid === comment.uuid && (
              <li className={styles.replyInput}>
                <ChatInput
                  project={project}
                  isSubmitting={isSubmitting}
                  replyTo={replyTo}
                  onCancelReply={() => setReplyTo(null)}
                  submit={(c) => {
                    onSubmitReply(c);
                    setReplyTo(null);
                  }}
                />
              </li>
            )}
            <li className={styles.comment}>
              {comment.attributes?.type === "log" ? (
                <Log comment={comment} />
              ) : (
                <CommentComponent
                  resources={resources}
                  comment={comment}
                  replies={repliesMap[comment.uuid] ?? []}
                  onReply={setReplyTo}
                />
              )}
            </li>
          </React.Fragment>
        ))
      ) : (
        <Placeholder />
      )}
      {isLoadingOlderComments && (
        <li className={styles.comment}>
          <CommentLoader />
        </li>
      )}
    </ul>
  );
}

export { Feed };
